const { buildQuestionLookup, isSousCritereVisible } = require("../shared/progress");

export default function IconSelectionCritere({ critereInfo, getMainActifNum, setMainActifNum, getNumberFiliereActif, setNumberCritereActif, setNumberSousCritereActif, data, getSouscritereInfo, setSouscritereInfo, Lang, recordNav }) {

    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */

    /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */

    /* --- GESTION DES TEXTES ET COULEURS BOUTONS --- */
    const getCardState = (value) => {
        if (value === 100) {
            return {
                btnClass: "btn-green",
                barClass: "backgreenBAR", // Using existing class in index.css
                text: Lang === "en" ? "Edit" : "Modifier"
            };
        } else if (value === 0) {
            return {
                btnClass: "btn-red",
                barClass: "backredBAR",
                text: Lang === "en" ? "Start" : "Commencer"
            };
        } else {
            return {
                btnClass: "btn-orange",
                barClass: "backorangeBAR",
                text: Lang === "en" ? "Resume" : "Poursuivre"
            };
        }
    };

    /* --- INCRÉMENTE LE NUMÉRO DU SOUS-CRITÈRE ACTIF --- */
    const handleClickFilieresToCriteres = (NumbsousCritere) => () => {
        if (recordNav) {
            recordNav();
        }
        setMainActifNum(getMainActifNum + 1);
        setNumberCritereActif(critereInfo.id - 1);
        setNumberSousCritereActif(NumbsousCritere - 1);
        setSouscritereInfo((data.data[getNumberFiliereActif].criteres[critereInfo.id - 1].sousCriteres[NumbsousCritere - 1].questions));
    }

    const currentPeriod = data?.data?.[getNumberFiliereActif];
    const currentCritere = currentPeriod?.criteres?.[critereInfo.id - 1]
        || currentPeriod?.criteres?.find((critere) => String(critere?.id) === String(critereInfo.id));
    const questionLookup = buildQuestionLookup(currentPeriod);

    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */

    return (
        <section className="menuCritere">
            <h3 className="menuCritereNom">- {critereInfo.nom}</h3>

            <div className="menuCritereGrid">
                {critereInfo.sousCriteres.map((souscritere, index) => {
                    const state = getCardState(souscritere.pourcentage);
                    const fullSousCritere = currentCritere?.sousCriteres?.[souscritere.id - 1]
                        || currentCritere?.sousCriteres?.find((entry) => String(entry?.id) === String(souscritere.id))
                        || souscritere;
                    return isSousCritereVisible(fullSousCritere, {
                        dataFiltres: currentPeriod?.filtres,
                        questionLookup,
                        critere: currentCritere,
                        period: currentPeriod
                    }) ? (
                        <div
                            key={`${index}-${souscritere.id}-card`}
                            className="subCritereCard"
                            onClick={handleClickFilieresToCriteres(souscritere.id)} // Moved onClick here
                        >

                            {/* LEFT SIDE: Name + Progress */}
                            <div className="subCritereContent">
                                <h4 className="subCritereName">{souscritere.nom}</h4>

                                <div className="subCritereProgress">
                                    <span className="progressText">{souscritere.pourcentage}%</span>
                                    <div className="progressContainer">
                                        <div
                                            className={`progressBar ${state.barClass}`}
                                            style={{ width: `${souscritere.pourcentage}%` }}
                                        ></div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT SIDE: Button (Centered vertically via CSS) */}
                            <div className="subCritereAction">
                                <div className={`subCritereButton ${state.btnClass}`}>
                                    {state.text}
                                    <i className="gg-arrow-long-right"></i>
                                </div>
                            </div>

                        </div>
                    ) : null
                })}
            </div>
        </section>
    );
}
